module.exports = __webpack_public_path__ + "static/media/tikal.a09022e8.png";